import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import { Colors } from '../../assets/styles/colors';

export const PaymentBottomButtonHint = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, calc(-100% - 30px));
`;

export const PaymentNoPaymentSubmissions = styled(Typography)`
  padding: 30px 20px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  color: ${Colors.TextSecondary};
`;

export const Wrapper = styled.div`
  overflow-y: auto;
`;

export const PaymentPageWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const TransactionsWrapper = styled.div`
  overflow-y: auto;
  flex-grow: 1;

  @media (min-width: 1000px) {
    width: 1000px;
    margin: 0 auto;
  }
`;
